// ============================================================================
// EduPath Sprint 5 - Offline Sync Provider
// ============================================================================
// Drop-in wrapper component that adds offline sync UI to the app.
// Place this at the root of your app (inside React providers).
//
// Usage:
//   import { OfflineSyncProvider } from './components/offline';
//
//   function App() {
//     return (
//       <OfflineSyncProvider>
//         <YourAppContent />
//       </OfflineSyncProvider>
//     );
//   }
// ============================================================================

import React from 'react';
import { SyncStatusBar } from './SyncStatusBar';
import { ConflictResolutionModal } from './ConflictResolutionModal';
import { SyncToast } from './SyncToast';

interface OfflineSyncProviderProps {
  children: React.ReactNode;
  /** Disable the bottom status bar */
  hideStatusBar?: boolean;
  /** Disable toast notifications */
  hideToasts?: boolean;
}

export const OfflineSyncProvider: React.FC<OfflineSyncProviderProps> = ({
  children,
  hideStatusBar = false,
  hideToasts = false,
}) => {
  return (
    <>
      {children}

      {/* Sync status bar at bottom of screen */}
      {!hideStatusBar && <SyncStatusBar />}

      {/* Toast notifications */}
      {!hideToasts && <SyncToast />}

      {/* Conflict resolution modal (renders when triggered) */}
      <ConflictResolutionModal />
    </>
  );
};

export default OfflineSyncProvider;
